const RELOAD_KEY = 'staleChunkReloadedBuild'
const BUILD = typeof __PP_SENTRY_RELEASE__ === 'undefined' ? '' : __PP_SENTRY_RELEASE__

// Chrome/Firefox, Safari, Safari when the host serves index.html for a missing chunk, and Vite's route CSS preload
const CHUNK_ERROR_PATTERNS = [
  'dynamically imported module',
  'Importing a module script failed',
  'not a valid JavaScript MIME type',
  'Unable to preload CSS',
]

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
}

/** Reloads to pick up the current chunk manifest, at most once per build so a chunk that stays missing can't loop. */
export const reloadOnceForStaleChunk = () => {
  if (!navigator.onLine) {
    return
  }
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === BUILD) {
      return
    }
    sessionStorage.setItem(RELOAD_KEY, BUILD)
  } catch {
    return
  }
  window.location.reload()
}
